/* Restores the original simulated purchase notice; this is not a live order feed. */
(() => {
  'use strict';
  if (window.__REFURB_PAGE__?.template !== 'index') return;
  const areas = [
    ['New Farm', 'Brisbane'], ['Paddington', 'Brisbane'], ['West End', 'Brisbane'],
    ['Parramatta', 'Sydney'], ['Surry Hills', 'Sydney'], ['Chatswood', 'Sydney'],
    ['Subiaco', 'Perth'], ['Fremantle', 'Perth'], ['Victoria Park', 'Perth'],
    ['Richmond', 'Melbourne'], ['Fitzroy', 'Melbourne'], ['South Yarra', 'Melbourne'],
  ];
  window.setTimeout(() => {
    if (document.getElementById('refurb-recent-purchase')) return;
    const laptops = (window.__REFURB_PRODUCTS__ || []).filter(product =>
      product.handle.startsWith('act-') && product.available && product.images?.length
    );
    if (!laptops.length) return;
    const product = laptops[Math.floor(Math.random() * laptops.length)];
    const area = areas[Math.floor(Math.random() * areas.length)];
    const hoursAgo = Math.floor(Math.random() * 61) + 12;
    const notice = document.createElement('aside');
    notice.id = 'refurb-recent-purchase';
    notice.setAttribute('aria-live', 'polite');
    notice.setAttribute('aria-label', 'Demo recent purchase notification');
    const photoLink = document.createElement('a');
    photoLink.className = 'recent-purchase-photo';
    photoLink.href = `/products/${encodeURIComponent(product.handle)}`;
    photoLink.setAttribute('aria-label', `View ${product.title}`);
    const image = document.createElement('img');
    image.src = product.images[0];
    image.alt = '';
    image.width = 64;
    image.height = 64;
    photoLink.append(image);
    const copy = document.createElement('div');
    copy.className = 'recent-purchase-copy';
    const label = document.createElement('p');
    label.className = 'recent-purchase-label';
    label.textContent = 'Recently purchased';
    const location = document.createElement('p');
    location.className = 'recent-purchase-location';
    location.textContent = `Someone from ${area[0]}, ${area[1]}`;
    const productLink = document.createElement('a');
    productLink.className = 'recent-purchase-product';
    productLink.href = photoLink.href;
    productLink.textContent = `${product.title} · ${hoursAgo} hours ago`;
    copy.append(label, location, productLink);
    const dismiss = document.createElement('button');
    dismiss.type = 'button';
    dismiss.className = 'recent-purchase-dismiss';
    dismiss.setAttribute('aria-label', 'Dismiss recent purchase notification');
    dismiss.textContent = '×';
    dismiss.addEventListener('click', () => notice.remove());
    notice.append(photoLink, copy, dismiss);
    document.body.append(notice);
  }, 5000);
})();
